import { useQuery } from '@tanstack/react-query';
import { getAxios } from '../../../../lib/axios';
import { WexCardTransaction } from '../types';
import { ActivityEndpoints } from '../../../../constants/endpoints/activityEndpoints.ts';

export function useWexCardTransactionQuery(activityId: number, cardId: string) {
  return useQuery<WexCardTransaction[]>({
    queryKey: [ActivityEndpoints.paymentCard.transactions(activityId, cardId)],
    queryFn: async () => {
      const response = await getAxios().get(ActivityEndpoints.paymentCard.transactions(activityId, cardId));
      return response.data;
    },
    enabled: !!activityId && !!cardId,
    retry: false
  });
}
